import React, { useRef } from 'react'
import icon from '../../../../assets/recovery-convert.png'
import { Button } from 'flowbite-react'
import { FaShare } from 'react-icons/fa'
import { Share } from '@material-ui/icons'
import moment from 'moment'
import StatusView from '../../../../components/StatusView/StatusView'
import { numberWithCommas } from '../../../../utils/formatNumber'
import ReceiptTemplate from '../ReceiptTemplate/ReceiptTemplate'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'



interface TransactionProps {
    transaction: any
}
const TransactionDetails = ({ transaction }: TransactionProps) => {

    const generatePDF = () => {

    };

    const transactionDetails = [
        { label: 'Transaction ID', value: transaction.id },
        { label: 'Transaction Date', value: moment(transaction?.dateCreated).format("DD-MMM-YYYY hh:mm:ss a") },
        { label: 'Email Address', value: transaction.customerEmail },
        { label: 'Transaction Amount', value: `${transaction.currency} ${numberWithCommas(transaction.amount)}` },
        { label: 'Settlement Amount', value: `${transaction.currency} ${numberWithCommas(transaction.settlementAmount)}` },
        { label: 'Fee', value: `${transaction.currency} ${numberWithCommas(transaction.fee)}` },
        { label: 'Payment Type', value: transaction.paymentType === "C" ? "CARD PAYMENT" : transaction.paymentType },
        { label: 'Order Reference', value: transaction.orderReference },
        { label: 'Payment Reference', value: transaction.paymentReference },
        { label: 'Narration', value: transaction?.narration },
        { label: 'Status', value: <StatusView status={transaction?.orderStatus} green="Successful" red="Failed" orange="Initiated" /> },
        { label: 'Response Message', value: transaction.paymentResponseMessage }
    ];


    return (
        <div className=''>
            <div>
                <img src={icon} className='my-3' alt="icon" />
                <div className='my-3'>
                    <p className='text-xl font-bold'>Transaction Details</p>
                    <p className='text-sm'>Kindly find your transaction details below</p>
                </div>
            </div>

            <div>
                {transactionDetails.map((detail, index) => (
                    <div key={index}>
                        <div className='flex my-4 items-center text-xs'>
                            <p>{detail.label}</p>
                            <p className='font-semibold ml-auto text-right'>{detail.value}</p>
                        </div>
                        <hr />
                    </div>
                ))}

            </div>
            

            <div className='flex justify-center my-4'>
                <Button className='rounded-full bg-custom-button-green' onClick={() => generatePDF()}>
                    <div className='flex items-center gap-4'>
                        <FaShare />
                        <p>Share transaction details</p>
                    </div>
                </Button>
            </div>
        </div>

    )
}

export default TransactionDetails
